import _ from 'lodash';
import { InterfaceActive } from '../../../interfaces/Active/interfaceActive';

export const sortByKey = (key: string, data: InterfaceActive[], ordem: string) => {
  if (ordem === 'asc') {
    return _.sortBy(data, key);
  }
  return _.sortBy(data, key).reverse();
};
